import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModulesContainerComponent } from './app.component';

const routes: Routes = [
  {
    path: '',
    component: ModulesContainerComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'universidades',
        loadChildren: () => import('./modules/universidad/universidad.module').then(m => m.UniversidadModule)
      },
      {
        path: 'programas',
        loadChildren: () => import('./modules/programas/programas.module').then(m => m.ProgramasModule)
      },
      {
        path: 'comunidad/docentes',
        loadChildren: () => import('./modules/docentes/docentes.module').then(m => m.DocentesModule)
      },
      {
        path: 'comparador',
        loadChildren: () => import('./modules/comparador/comparador.module').then(m => m.ComparadorModule)
      },
      {
        path: 'comunidad/estudiantes',
        loadChildren: () => import('./modules/estudiantes/estudiantes.module').then(m => m.EstudiantesModule)
      },
      {
        path: 'datos',
        loadChildren: () => import('./modules/datos/datos.module').then(m => m.DatosModule)
      },
      {
        path: 'estadistica',
        loadChildren: () => import('./modules/estadistica/estadistica.module').then(m => m.EstadisticaModule)
      }
      ,
      {
        path: 'publicaciones',
        loadChildren: () => import('./modules/publicaciones/publicaciones.module').then(m => m.PublicacionesModule)
      }
    ],
  },
  {
    path: '**', redirectTo: '', pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
